/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
interface VideoJSProps {
  options: any;
  onReady?: (player: any) => void;
}
export const VideoJS: React.FC<VideoJSProps> = ({
  options,
  onReady
}) => {
  const videoRef = useRef<HTMLDivElement | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const playerRef = useRef<any | null>(null);
  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current?.appendChild(videoElement);
      const player = playerRef.current = videojs(videoElement, options, () => {
        if (onReady) {
          onReady(player);
        }
      });
    } else {
      const player = playerRef.current;
      player.autoplay(options.autoplay || false);
      player.src(options.sources || []);
      player.on('click', () => {
        player.pause();
      });
    }
  }, [options, videoRef]);
  useEffect(() => {
    const player = playerRef.current;
    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);
  return <div data-vjs-player={true} data-sentry-component="VideoJS" data-sentry-source-file="VideoJS.tsx">
      <div ref={videoRef} />
    </div>;
};
export default VideoJS;